// Client HTTP condiviso per le chiamate al backend (/api).
// Il backend richiede un token Bearer su tutti gli endpoint (tranne /health e il login):
// ogni chiamata a /api deve passare da apiFetch, non da fetch diretto.

export const TOKEN_KEY = "auth_token";

export function getToken(): string | null {
  try {
    const t = localStorage.getItem(TOKEN_KEY);
    return t && t.trim() !== "" ? t : null;
  } catch {
    return null;
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

/** Sessione scaduta o non valida: elimina il token e riporta al login (una volta sola). */
export function handleUnauthorized(): void {
  clearToken();
  if (typeof window !== "undefined" && window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
}

/**
 * fetch + header Authorization. Non imposta Content-Type (lo decide il chiamante o il browser,
 * es. FormData). Su 401 chiude la sessione e reindirizza al login; la Response viene
 * comunque restituita cosi' i chiamanti esistenti continuano a funzionare.
 */
export async function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers);
  const token = getToken();
  if (token && !headers.has("Authorization")) {
    headers.set("Authorization", `Bearer ${token}`);
  }
  const res = await fetch(input, { ...init, headers });
  if (res.status === 401) {
    handleUnauthorized();
  }
  return res;
}

function filenameFromDisposition(value: string | null): string | null {
  if (!value) return null;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(value);
  if (star) {
    try {
      return decodeURIComponent(star[1]);
    } catch {}
  }
  const plain = /filename="?([^";]+)"?/i.exec(value);
  return plain ? plain[1] : null;
}

/**
 * Scarica un file protetto: un semplice <a href> / window.open non puo' inviare
 * l'header Authorization, quindi si scarica come blob e si salva da li'.
 */
export async function downloadFile(url: string, fallbackName?: string): Promise<void> {
  const res = await apiFetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  const name = fallbackName || filenameFromDisposition(res.headers.get("Content-Disposition")) || "download";
  const objectUrl = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(objectUrl), 10_000);
  }
}
